"use strict";
/**
 * DataEditForm
 *
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var DataEditFormElement_1 = __importDefault(require("../../screens/DataEditView/DataEditFormElement"));
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../store/crude/crude.selector");
var material_1 = require("@mui/material");
var getDefaultValueForColumnType_1 = __importDefault(require("./util/getDefaultValueForColumnType"));
var commonTypes_1 = require("../../shared/types/commonTypes");
var DataEditForm = function (props) {
    var entity = props.entity;
    var crudeSchema = react_redux_1.useSelector(crude_selector_1.getCrudeSchema);
    var entitySchema = crudeSchema && crudeSchema.find(function (entitySchema) { return entitySchema.name === entity; });
    var screenDesign = react_redux_1.useSelector(crude_selector_1.getScreenDesign);
    var _a = react_1.useState(), disableJoinColumns = _a[0], setDisableJoinColumns = _a[1];
    react_1.useEffect(function () {
        props.disableJoinColumns && setDisableJoinColumns(props.disableJoinColumns);
    }, [props.disableJoinColumns]);
    var getInitialData = function () {
        var colData = {};
        entitySchema && entitySchema.columns.map(function (col) {
            // hier werden values vordefiniert, wie zum Beispiel beim Add in den Tabellen der OutgoingReferences
            if (props.embeddingEntityFilter && props.embeddingEntityFilter.key === col.name) {
                colData[col.name] = props.embeddingEntityFilter.value;
            }
            else {
                colData[col.name] = getDefaultValueForColumnType_1.default(col.columnType);
            }
        });
        var initialData = {
            data: colData,
            instancePermissions: {},
            entityReferencePreviews: {},
        };
        return initialData;
    };
    var _b = react_1.default.useState(props.data || getInitialData()), data = _b[0], setData = _b[1];
    react_1.useEffect(function () {
        props.data && setData(props.data);
    }, [props.data]);
    return (react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } }, entitySchema && entitySchema.columns.map(function (element, index) {
        return (react_1.default.createElement(material_1.Box, { key: index, sx: { pb: 2 } },
            react_1.default.createElement(DataEditFormElement_1.default, { schema: element, disableJoinColumns: disableJoinColumns, id: props.id, entity: entity, embeddingEntityFilter: props.embeddingEntityFilter, data: data, fullWidth: commonTypes_1.ScreenDesign.mobile === screenDesign, onChangeData: function (data) {
                    setData(data);
                    props.onChangeData && props.onChangeData(data);
                } })));
    })));
};
exports.default = DataEditForm;
